import * as csrf from './csrf';
import { makeModal } from './modals';

const checkAuthy = (seconds: number, force: boolean, options) => {
  const params = new URLSearchParams({ seconds: String(seconds) });

  if (force) {
    params.set('force', 'true');
  }

  return fetch('/accounts/authy/check?' + params.toString())
    .then((response) => response.json())
    .then((data) => {
      if (data.needs_authy) {
        options.yes(data.instruction);
      } else {
        options.no();
      }
    });
};

const submitHandler = (e) => {
  e.preventDefault();
  const form = e.target;
  // check if we should bypass
  const bypass = form.dataset.bypassAuthy === 'true';
  if (bypass) {
    return true;
  }
  const seconds = parseFloat(form.dataset.authy);
  // Some users have to confirm a second factor every time, so how long ago they last
  // confirmed one can never let them through.
  const force = form.dataset.authyForce === 'true';
  checkAuthy(seconds, force, {
    yes: function (instruction) {
      const body = `
        <label class="block text-sm font-medium leading-5 w-full text-sp-neutral-900">${instruction}</label>
        <div class="sp-input-field-div-wrapper flex">
          <input type="text" name="code" class="sp-input sp-input-field " placeholder="" value="" autocomplete="one-time-code" inputmode="numeric">
        </div>
      `;
      const onSubmit = ({ code }) => {
        // The token goes with the form rather than being checked on its own, so that
        // it authorises this publish and nothing else. That means the server reports a
        // rejected token as an error on the form we are about to submit.
        form.querySelector('input[name="authy_token"]').value = code;
        csrf.replaceCSRFTokens();
        form.dataset.bypassAuthy = 'true';
        form.submit();

        // makeModal closes itself once we settle
        return Promise.resolve();
      };
      makeModal('Authentication Confirmation', body, 'OK', 'Cancel', onSubmit);
    },
    no: function () {
      form.dataset.bypassAuthy = 'true';
      form.submit();
    },
  });

  return false;
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[data-authy]').forEach((element) => {
    element.addEventListener('submit', submitHandler, false);
  });
});
